import { useEffect, useRef, useState } from "react";

/**
 * Reveal — tiny IntersectionObserver wrapper that adds .is-visible
 * when the element enters the viewport. Respects prefers-reduced-motion
 * via CSS.
 */
export default function Reveal({
  as: Tag = "div",
  className = "",
  delay = 0,
  children,
  ...rest
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // stagger
            const id = setTimeout(() => setVisible(true), delay);
            io.unobserve(entry.target);
            return () => clearTimeout(id);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag
      ref={ref}
      className={`g1-reveal ${visible ? "is-visible" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
